// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2hGWF","name":"Header_name__3rhhQ","birthday":"Header_birthday__2f3Pj","skeleton":"Header_skeleton__3e_bB"};